import React from 'react';

import { createTheme } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import {
  DeprecatedThemeOptions,
  ThemeProvider as MuiThemeProvider,
} from '@mui/material/styles';
import type { ReactNode } from 'react';

import { getThemeByName, WebOrderTheme } from './themes/base';

// declare module '@mui/styles/defaultTheme' {
//   // eslint-disable-next-line @typescript-eslint/no-empty-interface
//   interface DefaultTheme extends Theme {}
// }

type OuterProps = {
  children: ReactNode;
  themeName: WebOrderTheme;
  fontName: string;
};

export const ThemeProvider = (props: OuterProps) => {
  const { children, themeName, fontName } = props;
  const currentTheme = getThemeByName(themeName, fontName);

  return <MuiThemeProvider theme={currentTheme}>{children}</MuiThemeProvider>;
};

export const createWebOrderTheme = (props?: DeprecatedThemeOptions): Theme =>
  createTheme(props);
